import React, { useState, useEffect, useContext, useRef } from 'react';
import ReactToPrint from 'react-to-print';
import SimpleTable from '../../components/tables/simpleTable';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DatePicker from '../../components/filters/datePicker';
import DateTimePicker from '../../components/filters/DateTimePicker';
import DropDownFilter from '../../components/filters/dropDownFilter';
import AsyncDropDownFilter from '../../components/filters/asyncDropdownFilter';
import { FaPlus, FaPrint } from "react-icons/fa";
import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, productSalesFormatter } from '../../components/formatters/defFormatter';
import { dateFormatter, dateViewerFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { Space, Input, Tag, Button, Tabs } from 'antd';
import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";
import { DataContext } from '../../init/getData';
import { printProductSalesReport } from './printReports';
import DataFilter from '../../components/filters/dataFilter';

function ProductSales(props) {
  let { } = props;

  const { userData, settingData, api, devData, refWareHouseData, refCategory, categoryData, refProductData, productData, refAllUserData, allUserData, refAccountData, accountData } = useContext(DataContext);

  const [loadingCounter, setLoadingCounter] = useState(0);
  const [data, setData] = useState([]);
  const [showPrintReport, setShowPrintReport] = useState(false);
  const printRef = useRef();

  const createdBy = parseInt(userData.id);
  const userRole = userData.role;
  const defaultWareHouseId = userData?.role?.defaultWareHouseId;  
  const today = new Date().toISOString().split('T')[0];    
  const formatDateTimeLocal = (date = new Date()) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    "T" +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes())
  );
};
const now = formatDateTimeLocal(new Date());       

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);

  const [filter, setFilter] = useState({
    search: '', isActive: 'true', fromDate: now, toDate: now, isOrder: false,
    productId: null, wareHouseId: defaultWareHouseId, transactionType: null, categoryId: null, createdBy: null, deliveryId: null
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [name, setName] = useState('');
  const [category, setCategory] = useState([]);

  const table = 'productSales';
  const title = 'ProductSalesByItem';
                  
  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const resetForm = () => {
    setCategory({ createdBy: createdBy })
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setCategory(
      {
        name: idRow?.name || '',
        createdBy: createdBy,
      }
    )
  }, [idRow]);

   //Get Data refs 
    useEffect(() => {
      const fetchData = async () => {
        try {
          if (!devData.isCloud) {
            await refAccountData();
          }
          setIsLoading(false);
        } catch (error) {
          console.error('Error refreshing data Contact Support');
        }
      };
      fetchData();
    }, []);
  
  const deliveryData = accountData.filter(item => item.type === 'Delivery');
  // Delivery Options
  const deliveryOptions = deliveryData?.map(item => ({
    value: item.id,
    label: `${item?.name} [${item?.phone}]`,
  }))
  deliveryOptions.push({ value: null, label: 'All ' + devData.deliveryName })
const selectedDelivery = deliveryOptions.filter(option => option.value === filter.deliveryId);

  //Excel Data
  const getExcelData = (data, getSummary) => {
    const transformedData = [];
    data.forEach(item => {
      const newItem = {
        id: item.id,
        createdAt: item.createdAt,
        barcode: item.product?.barcode,
        name: item.product?.name,
        quantity: item.quantity,
        type: item.transaction?.type,
        cost: item.cost,
        profit: item.profit,
      };
      transformedData.push(newItem);
    });

    const summary = {
      TotalSales: getSummary.totalSales,
      TotalCost: getSummary.totalCost,
      TotalDiscounts: getSummary.totalDiscounts,
      TotalProfit: getSummary.totalProfit,
    }
    return { transformedData, summary };
  };

  let newColumnDefs = [
    { title: 'CreatedAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Date', dataIndex: 'transaction', render: (transaction) => (transaction?.date) },
    { title: 'Barcode', dataIndex: 'product', render: (product) => (product?.barcode), width: '12%' },
    { title: 'Product', dataIndex: 'product', render: (product) => (product?.name) },   
     {
      title: devData.deliveryName,
      dataIndex: 'transaction',
      render: (transaction, record) => {
        if (devData.isCloud) {
          return record?.deliveryNameCloud;
        } else {
          return transaction?.delivery?.name;
        }
      }
    },
    { title: 'Qty', dataIndex: 'quantity', render: (quantity, record) => (numberFormatter(quantity, 2) + ' ' + record?.product?.unit) },
    { title: 'Type', dataIndex: 'transaction', render: productSalesFormatter },
    { title: 'Total', dataIndex: 'totalPrice', render: numberFormatter },
    { title: 'Cost', dataIndex: 'cost', render: numberFormatter },
    { title: 'Profit', dataIndex: 'profit', render: numberFormatter },  
  ];

  useEffect(() => {
    setColumnDefs(newColumnDefs);
  }, []);

  const formView = (
    <div style={{ userSelect: 'none' }}>
    </div>);

  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '35%', transform: 'translateX(-30%)' }}>
      <div>
        <span className='table-footer footer-one'>Total Items Sold: {numberFormatter(data?.summary?.totalItems, 2)}</span>
        <span className='table-footer footer-green'>Total Sales: {numberFormatter(data?.summary?.totalSales, 2)}{settingData.currency}</span>
        <span className='table-footer footer-red'>Total Cost: {numberFormatter(data?.summary?.totalCost, 2)}{settingData.currency}</span>
        <span className='table-footer footer-yellow'>Total Discounts: {numberFormatter(data?.summary?.totalDiscounts, 2)}{settingData.currency}</span>
        <span className='table-footer footer-green'>Total Profit: {numberFormatter(data?.summary?.totalProfit, 2)}{settingData.currency}</span>
      </div>
    </div>
  );

 
const groupByCategory = (data) => {
  if (!data?.data) return {};
  
  const grouped = {};
  data.data.forEach(item => {
    console.log(item);
  
    // Properly access the category name through the nested structure
    const categoryName = item?.product?.category?.name || 'Uncategorized';
    
    if (!grouped[categoryName]) {
      grouped[categoryName] = [];  
    }
    grouped[categoryName].push(item);
  });
  
  // Calculate totals for each category
  Object.keys(grouped).forEach(category => {
    const items = grouped[category];
    const categoryTotal = items.reduce((sum, item) => sum + (item.totalPrice || 0), 0);
    grouped[category].total = categoryTotal;
  });
  
  return grouped;  
};

  const groupedData = groupByCategory(data);

// Print Report Component
const PrintReport = React.forwardRef(({ groupedData, filter, settingData, allUserData }, ref) => {
  const selectedUser = allUserData?.find(user => user.id === filter.createdBy);
  const selectedCategory = categoryData?.find(cat => cat.id === filter.categoryId);
  const selectedDelivery = accountData?.find(del => del.id === filter.deliveryId);
  
  return (
    <div ref={ref} style={{ padding: '20px', fontFamily: 'Arial' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>Sales Report</h1>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div>
          <strong>From Date:</strong> {filter.fromDate}
        </div>
        <div>
          <strong>User:</strong> {selectedUser ? selectedUser.name : 'All Users'}
        </div>
        <div>
          <strong>To Date:</strong> {filter.toDate}
        </div>
      </div>
      
      <div style={{ marginBottom: '10px' }}>
        <strong>{devData.deliveryName}:</strong> {selectedDelivery ? `${selectedDelivery.name} [${selectedDelivery.phone}]` : 'All'}
      </div>
      
      {Object.keys(groupedData).map(category => (
        <div key={category} style={{ marginBottom: '30px', pageBreakInside: 'avoid' }}>
          <h3 style={{ marginBottom: '10px', borderBottom: '1px solid #ddd', paddingBottom: '5px' }}>{category}</h3>
          
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '10px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f2f2f2' }}>
                <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Item</th>
                <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Type</th>
                <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>{devData.deliveryName}</th>
                <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Qnty</th>
                <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Total</th>
              </tr>
            </thead>
            <tbody>
              {groupedData[category].map((item, index) => (
                <tr key={index}>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.product?.name}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>{item.transaction?.type}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd' }}>
                    {devData.isCloud ? item?.deliveryNameCloud : item.transaction?.delivery?.name}
                  </td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{numberFormatter(item.quantity, 2)}</td>
                  <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>{numberFormatter(item.totalPrice, 2)}{settingData.currency}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: '#f2f2f2', fontWeight: 'bold' }}>
                <td colSpan="3" style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>Total:</td>
                <td style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'right' }}>
                  {numberFormatter(
                    groupedData[category].reduce((sum, item) => sum + Number(item.totalPrice || 0), 0),
                    2
                  )}
                  {settingData.currency}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      ))}
      
      <div style={{ marginTop: '30px', borderTop: '2px solid #000', paddingTop: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', textAlign: 'right', flexDirection: 'column', alignItems: 'flex-end' }}>
          <div>
            <strong>Total Sales:</strong> {numberFormatter(data?.summary?.totalSales, 2)} {settingData.currency}
          </div>
          <div>
            <strong>Discounts:</strong> {numberFormatter(data?.summary?.totalDiscounts, 2)} {settingData.currency}
          </div>
          <div>
            <strong>Total:</strong> {numberFormatter((data?.summary?.totalSales || 0) - (data?.summary?.totalDiscounts || 0), 2)} {settingData.currency}
          </div>
          <div>
            <strong>Total Cost:</strong> {numberFormatter(data?.summary?.totalCost, 2)} {settingData.currency}
          </div>
          <div>
            <strong>Total Profit:</strong> {numberFormatter(data?.summary?.totalProfit, 2)} {settingData.currency}
          </div>
        </div>
      </div>
    </div>
  );
});

  return (
    <div className='card'>        
    
      <div>  
        <DateTimePicker setFilter={setFilter} filter={filter} />
        <DropDownFilter setFilter={setFilter} filterBy={'categoryId'} placeHolder={'All Category'} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
        <AsyncDropDownFilter 
          setFilter={setFilter} 
          filterBy={'productId'} 
          placeHolder={'All Product'} 
          filter={filter} 
          setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} 
        />
        <DropDownFilter setFilter={setFilter} filterBy={'createdBy'} placeHolder={'All User'} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
        <DataFilter selectedOption={selectedDelivery} setFilter={setFilter} dataOptions={deliveryOptions} filterBy={'deliveryId'} placeHolder={'All '+ devData.deliveryName} />
        <DropDownFilter setFilter={setFilter} filterBy={'wareHouseId'} placeHolder={'All ' + devData.wareHouseName} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />
        
        <div style={{ marginTop: '5px' }}>
          <Button 
            type="primary" 
            icon={<FaPrint />} 
            onClick={() => setShowPrintReport(true)}
          >
            Print
          </Button>
        </div>
      </div>  

      {loadingCounter < 4 &&
        <Loader />
      }

      {loadingCounter == 4 &&
        <>
          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ category }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, category }}
          />

          {/* Print Report Modal */}
          {showPrintReport && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1050
            }}>
              <div style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '5px',
                width: '80%',
                maxHeight: '90vh',
                overflow: 'auto'
              }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
                  <Button 
                    type="primary" 
                    icon={<FaPrint />} 
                    onClick={() => printProductSalesReport({
                      groupedData,
                      filter,
                      settingData,
                      allUserData,
                      data
                    })}
                  >
                    Print Report
                  </Button>
                  <Button 
                    style={{ marginLeft: '10px' }} 
                    onClick={() => setShowPrintReport(false)}
                  >
                    Close
                  </Button>
                </div>
                
                <PrintReport 
                  ref={printRef} 
                  groupedData={groupedData} 
                  filter={filter} 
                  settingData={settingData}
                  allUserData={allUserData}
                />
              </div>
            </div>
          )}
        </>
      }
    </div>
  )
}

export default ProductSales;